import axios from "../../utils/axios";
import type { HazardDTO } from "../types/scoreMiscDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchAllHazards = () => axios.get<HazardDTO[]>(`${apiUrl}/Hazard/GetAll`);

const hazardService = {
    fetchAllHazards,
};

export default hazardService;
